module.exports = __webpack_public_path__ + "img/icon-consumption-statistics.a9f63b6e.svg";